import _extends from '@babel/runtime/helpers/extends';
import * as React from 'react';
import { useFormFieldContext } from '../../../../hooks/useFormFieldContext.js';
import '../../../../../../../VisualAssets/IconV3/index.js';
import { IconV3 as IconV3Memoized } from '../../../../../../../VisualAssets/IconV3/Icon.js';

var ControlIcon = /*#__PURE__*/React.memo(function (props) {
  var _useFormFieldContext = useFormFieldContext(),
    isDisabled = _useFormFieldContext.isDisabled;
  return /*#__PURE__*/React.createElement(IconV3Memoized, _extends({
    staticSize: "20",
    color: isDisabled ? 'state.disabled' : 'base.subtle'
  }, props));
});
ControlIcon.displayName = 'FormField.ControlIcon';

export { ControlIcon };
//# sourceMappingURL=ControlIcon.js.map
